<template>
  <div class="park-info-warp" v-loading="loading">
    <parkInfoHeader :statisticalOption="statisticalOption" :switchTypeOption="switchTypeOption" :switchType.sync="switchType"></parkInfoHeader>
    <div class="park-distributed">
      <div class="common-card-panel industry show-shadow show-radius">
        <div class="panel--head">
          <span class="panel--title panel--tile_split">企业行业分布</span>
        </div>
        <div style="height: calc(100% - 50px);">
          <barChart v-if="industryInfo && industryInfo.length > 0" :xDataOptions="industryXData" :yDataOptions="industryYData" id="bar-chart-1" height="480px"></barChart>
          <emptyBox v-else />
        </div>
      </div>
      <div class="industry-right">
        <div class="common-card-panel show-shadow show-radius">
          <div class="panel--head">
            <span class="panel--title panel--tile_split">企业成立年限分布</span>
          </div>
          <pieChart :dataOptions="enterpriseEstablishYear" id="pic-chart-1" height="208px"></pieChart>
        </div>
        <div class="common-card-panel show-shadow show-radius">
          <div class="panel--head">
            <span class="panel--title panel--tile_split">企业注册资本分布</span>
          </div>
          <pieChart :dataOptions="enterpriseRegisterCapital" id="pic-chart-2" height="208px"></pieChart>
        </div>
      </div>
    </div>
    <!-- 企业名单 -->
    <div class="park-company show-shadow show-radius">
      <div class="common-card-panel panel--head">
        <span class="panel--title panel--tile_split">企业名单</span>
      </div>
      <searchhead-checkbox searchType="6" :hideSome='true' @set-condition="setCondition" ref="SearchheadCheckbox"></searchhead-checkbox>
      <div v-loading.lock="waiting">
        <company-card-list @isUnlock-Change="isUnlockChange" :resetUnlockS="isUnlock" :companyType="11" class="ccl" style="padding-bottom:0" ref="cardlist" :batchActions="batchActions" :list="list"
          @handle-page-num="handlePageNum" @handle-page="handlePage" @getData="getData">
          <div class="font-15-md">
            小T为您找到11<span class="blueColor" style="color: #5088FF;"> {{ _totalElements }} </span>家企业资源
          </div>
          <template v-slot:beforeBatch>
            <el-button class="gbBatchBtn" :loading="actionLoading" type="info" plain size="small" v-interestExpire @click="batchUnlockFnbefore">解锁前500</el-button>
          </template>
          <template v-slot:two>
            <intel-sort @sortChange="sortChange" :value="sortValue"></intel-sort>
          </template>
        </company-card-list>
      </div>
      <robot />
      <!-- 右侧悬浮箭头 -->
      <right-float ref="rightFloat" :globalRfType="false" @scrollToView="scrollToView"></right-float>
      <div id="bottom" ref="bottom"></div>
      <unlock-dialog-batch :show.sync="unlockDialogShowBatch" :maxTotal="list.total" title="批量解锁" :confirmPromise="contactsNumBatchConfirmBatch"></unlock-Dialog-Batch>
      <!-- 批量解锁提示 -->
      <batch-unlock-tip ref="batchUnlockTip"></batch-unlock-tip>
    </div>
  </div>

</template>

<script>
import { mapState } from 'vuex'
import pieChart from '../components/pieChart.vue'
import barChart from '../components/barChart.vue'
import parkInfoHeader from '../components/parkInfoHeader.vue'
import SearchheadCheckbox from '@/views/clue/components/searchHeadCheckBox'
import CompanyCardList from '@/views/clue/components/companyCardList'
import Robot from '@/views/clue/components/robot'
import intelSort from '@/views/wigects/intelSort'
import unlockDialogBatch from '@/views/clue/components/unlockDialogBatch'
import batchUnlockTip from '@/components/batchUnlockTip'
import RightFloat from '@/components/rightFloatBtn'
import { searchByCondition, searchByConditionUnlock } from '@/views/clue/api/index'
import { queryParkInfo, companyEstablishment, companyRegisteredCapital, companyTypeCount } from '../api/index'
export default {
  name: 'parkInfo',
  provide() {
    return {
      unlockSourceType: 11
    }
  },
  components: {
    pieChart,
    barChart,
    parkInfoHeader,
    SearchheadCheckbox,
    CompanyCardList,
    Robot,
    intelSort,
    unlockDialogBatch,
    batchUnlockTip,
    RightFloat
  },
  data() {
    return {
      loading: false,
      switchType: 'reg',
      switchTypeOption: [
        { name: '注册地址', value: 'reg' },
        { name: '经营地址', value: 'op' }
      ],
      statisticalOption: [
        { name: '企业总数量', tag: 4, opNumber: 0, regNumber: 0 },
        { name: '高新技术企业数量', tag: 1, opNumber: 0, regNumber: 0 },
        { name: '专精特新企业数量', tag: 2, opNumber: 0, regNumber: 0 },
        { name: '科技中小企业数量', tag: 3, opNumber: 0, regNumber: 0 }
      ],
      pieUnlockSourceData: [
        { value: 1048, name: 'Search Engine Search Engine Search Engine Search Engine Search Engine' },
        { value: 735, name: 'Direct Search Engine Search Engine Search Engine Search Engine' },
        { value: 580, name: 'Email' },
        { value: 484, name: 'Union Ads' },
        { value: 300, name: 'Video Ads' }
      ],
      // optionsTime: [
      //   { value: null, label: '默认排序' },
      //   { value: 1, label: '成立时间从早到晚' },
      //   { value: 2, label: '成立时间从晚到早' }
      // ],
      sortType: { sortType: null, sortField: null },
      sortValue: null,
      totalElements: 0,
      listTip: '近12个月内新注册',
      list: {
        pageNum: 1,
        pageSize: 10,
        total: 0,
        tab: 1,
        tableData: []
      },
      categoryId: '',
      areaCodeId: '',
      waiting: false,
      lastParams: {},
      filterValue: 'word',
      unlockDialogShowBatch: false,
      companyList: [],
      actionLoading: false,
      scrollTop: 0,
      isUnlock: false,
      industryInfo: null,
      industryXData: null,
      industryYData: null,
      enterpriseEstablishYearData: null,
      enterpriseEstablishYear: [],
      enterpriseRegisterCapitalData: null,
      enterpriseRegisterCapital: [],
    }
  },
  watch: {
    switchType(val) {
      this.getSwitchTypeData()
      this.list.pageNum = 1
      this.newCompany()
    }
  },
  computed: {
    ...mapState({
      surplus: state => state.user.surplus,
      staffInfo: state => state.user.staffInfo
    }),
    _totalElements() {
      if (this.totalElements < 100) return this.totalElements
      if (this.totalElements < 200000) return `${this.totalElements.toString().split('').reduce((res, v) => res ? res + 0 : v, '')}+`
      return '200000+'
    },
    batchActions() {
      return this.surplus < 1 ? [false, true, false] : [true, true, false]
    },
    parkId() {
      return this.$route.query.parkId
    }
  },
  beforeDestroy() {
    this.getPageWrapPadding()
    this.listenerFunction()
  },
  mounted() {
    this.newCompany()
    this.listenerFunction()
  },
  created: function () {
    const arr = [this.getQueryParkInfo(), this.getCompanyEstablishment(), this.getCompanyRegisteredCapital(), this.getCompanyTypeCount()]
    this.loading = true
    Promise.all(arr).then((values) => {
      this.loading = false
    }).catch((error) => {
      this.loading = false
    })
  },
  methods: {
    getSwitchTypeData() {
      this.loading = true
      if (this.industryInfo instanceof Array && this.industryInfo.length > 0) {
        this.industryInfo = this.industryInfo.sort((a, b) => a[`${this.switchType}Number`] - b[`${this.switchType}Number`]);
        this.industryXData = this.industryInfo.map(item => item.industry)
        this.industryYData = this.industryInfo.map(item => {
          return item[`${this.switchType}Number`] ? item[`${this.switchType}Number`] : 0
        })
      }
      if (this.enterpriseRegisterCapitalData instanceof Array && this.enterpriseRegisterCapitalData.length > 0) {
        this.enterpriseRegisterCapital = this.enterpriseRegisterCapitalData.map(f => {
          return {
            ...f,
            name: f.capital,
            value: f[`${this.switchType}Number`]
          }
        })
      }
      if (this.enterpriseEstablishYearData instanceof Array && this.enterpriseEstablishYearData.length > 0) {
        this.enterpriseEstablishYear = this.enterpriseEstablishYearData.map((f) => {
          return {
            ...f,
            name: f.date,
            value: f[`${this.switchType}Number`]
          }
        })
      }
      this.loading = false
    },
    async getCompanyTypeCount() {
      try {
        const { data, code } = await companyTypeCount({
          parkId: this.parkId
        })
        if (code === 200 && data && data instanceof Array && data.length > 0) {
          this.statisticalOption.forEach(f => {
            const obj = data.find(item => Number(item.tag) == f.tag)
            if (obj) {
              f.opNumber = obj.opNumber
              f.regNumber = obj.regNumber
            }
          })
        }
      } catch (error) { } finally {
      }
    },
    async getCompanyRegisteredCapital() {//园区企业注册资本分布
      try {
        const { data, code } = await companyRegisteredCapital({
          parkId: this.parkId
        })
        if (code === 200 && data && data instanceof Array && data.length > 0) {
          this.enterpriseRegisterCapitalData = data
          this.getSwitchTypeData()
        }
      } catch (error) { } finally {
      }
    },
    async getCompanyEstablishment() {
      try {
        const { data, code } = await companyEstablishment({//园区企业成立年限分布
          parkId: this.parkId
        })
        if (code === 200 && data && data instanceof Array && data.length > 0) {
          this.enterpriseEstablishYearData = data
          this.getSwitchTypeData()
        }
      } catch (error) { } finally {
      }
    },
    async getQueryParkInfo() {
      try {
        const { data, code } = await queryParkInfo({
          parkId: this.parkId
        })
        if (code === 200 && data && data instanceof Array && data.length > 0) {
          this.industryInfo = data
          this.getSwitchTypeData()
        }
      } catch (error) { } finally {
      }
    },
    goList() {
      this.$router.push('/zxk/junbros/parkCustomer')
    },
    setCondition(val) {
      this.list.pageNum = 1
      this.lastParams = val
      this.newCompany()
    },
    resetUnlockQ(val) {
      this.isUnlock = val
    },
    listenerFunction(e) {
      document.addEventListener('scroll', this.handleScroll, true)
    },
    handleScroll(event) {
      this.scrollTop = event.target.scrollTop
    },
    scrollToView(val) {
      document.getElementById(val).scrollIntoView({
        block: 'start',
        inline: 'nearest',
        behavior: 'smooth'
      })
    },
    // 过滤解锁
    isUnlockChange(val) {
      this.isUnlock = val
      this.newCompany()
    },
    sortChange(v) {
      this.list.pageNum = 1
      this.sortType = v
      this.sortValue = v.sortType ? `${v.sortField}-${v.sortType}` : null
      this.newCompany()
    },
    getData() {
      this.newCompany()
    },
    updateTip() {
      const { estiblishTime } = this.lastParams
      if (!estiblishTime || estiblishTime.length === 0) {
        this.listTip = '近12个月内新注册' // default
      } else if (estiblishTime.includes('1-12个月')) {
        this.listTip = '近1-12个月内新注册'
      } else if (estiblishTime.includes('1个月以内')) {
        this.listTip = '近1个月内新注册'
      }
    },
    removeHtml(str) {
      const reTag = /<(?:.|\s)*?>/g
      return str.replace(reTag, '').replace(/&nbsp;/ig, '')
    },
    async newCompany() {
      this.waiting = true
      let isUnlockN = this.isUnlock ? 1 : 0
      const params = {
        parkId: this.parkId,
        pageNum: this.list.pageNum,
        pageSize: this.list.pageSize,
        ...(this.sortType || {}),
        word: this.$route.query.word,
        isUnLock: parseInt(isUnlockN),
        ...this.lastParams,
        parkType: this.switchType == 'reg' ? 0 : 1,//园区类型 0.注册地址 1.经营地址
      }
      try {
        const { data } = await searchByCondition(params)

        this.list.total = data.total > 15000 ? 15000 : data.total
        this.totalElements = data.total
        this.list.tableData = data.items
        this.updateTip()
      } catch (error) { } finally {
        this.waiting = false
      }
    },
    handlePage(val) {
      if (this.list.pageNum !== val) {
        this.list.pageNum = val
        this.newCompany()
      }
    },
    handlePageNum(val) {
      this.list.pageNum = 1
      this.list.pageSize = val
      this.newCompany()
    },
    // 批量解锁前500
    batchUnlockFnbefore() {
      // 重新获取解锁数据
      this.$store.commit('SET_FREQUENCY', this.$store.state.user.frequency + 1)
      this.unlockDialogShowBatch = true
    },
    async contactsNumBatchConfirmBatch() {
      let isUnlockN = this.isUnlock ? 1 : 0
      const params = {
        parkId: this.parkId,
        pageNum: this.list.pageNum,
        pageSize: this.list.pageSize,
        source: 11,
        ...(this.sortType || {}),
        word: this.$route.query.word,
        ...this.lastParams,
        isUnLock: parseInt(isUnlockN),
        parkType: this.switchType == 'reg' ? 0 : 1,//园区类型 0.注册地址 1.经营地址
      }
      try {
        const { data, code } = await searchByConditionUnlock(params)
        if (code === 200) {
          if (this.staffInfo.demonstrationTag != 1) {
            this.$message.warning('批量解锁中，所需时长5分钟，请稍后在解锁列表中查看')
          }
          this.newCompany()
          this.$refs.batchUnlockTip.getUnlockBatchTip()
          this.$refs.batchUnlockTip.tipTitleF('2')
        }
      } catch (error) { } finally {
      }
    }
  },
}
</script>

<style lang="scss" scoped>
.park-info-warp {
  ::v-deep .show-radius {
    border-radius: 2px;
  }
  ::v-deep .show-shadow {
    box-shadow: 0 2px 6px 0 rgba(20, 20, 21, 0.04);
  }
  ::v-deep .common-card-panel {
    background: #fff;
    padding: 0;
  }
  .panel--head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 16px 16px 12px;
    height: 49px;
    .panel--title {
      font-size: 1.1428571429rem;
      font-weight: 700;
      color: #1b253a;
      &.panel--tile_split:before {
        content: "";
        width: 3px;
        height: 16px;
        background: #186bfc;
        display: inline-block;
        vertical-align: middle;
        font-size: 0;
        margin-right: 8px;
      }
    }
  }
  .park-distributed {
    height: 530px;
    display: flex;
    flex-direction: row;
    margin-top: 16px;
    .industry {
      flex: 1 1;
    }
    .industry-right {
      margin-left: 16px;
      width: 31%;
      min-width: 380px;
      height: 100%;
      .common-card-panel:first-child {
        margin-bottom: 16px;
      }
    }
  }
  .park-company {
    margin-top: 16px;
  }
  .ccl {
    margin: 0 auto;
    margin-bottom: 24px;
    margin-top: 30px;
    ::v-deep .recommend {
      margin: 0;
    }
  }
}
.gbBatchBtn {
  &.el-button {
    color: #333333;
    background: rgba(255, 255, 255, 0.2);
    box-shadow: 0px 2px 4px 0px #edeef3;
    border-radius: 4px;
    border: 1px solid #bbbeca;
    margin-left: 8px;
  }
}
</style>
